export default "__VITE_ASSET__Bs5fYuVn__"